module.exports = __webpack_public_path__ + "static/media/8D.62caedf7.svg";